export const DEFAULT_FIELDS_WARNING_MODAL_PROPS = {
  contentWidth: '300px',
  confirmButtonVariant: 'light',
} as const;
